var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var models;
    (function (models) {
        var DropZoneWorkflowBlock = /** @class */ (function (_super) {
            __extends(DropZoneWorkflowBlock, _super);
            function DropZoneWorkflowBlock(id, required) {
                var _this = _super.call(this, id, 99 /* DropZone */, "Drag Shape Here") || this;
                _this.logType = "DropZoneWorkflowBlock";
                _this.width = 120;
                _this.height = 70;
                _this.xPadding = 15;
                _this.yPadding = 40;
                _this.attributes = { id: _this.id, class: "drop-zone-workflow-block", "data-class": "workflowBlock", "data-id": "svgDropZone" };
                _this.optionalAttributes = { id: _this.id, class: "optional-drop-zone-workflow-block", "data-class": "workflowBlock", "data-id": "svgDropZone" };
                _this.optionalTextAttributes = { class: "optional-drop-zone-text" };
                _this.required = required;
                return _this;
            }
            DropZoneWorkflowBlock.prototype.getBottomPadding = function () {
                return this.yPadding;
            };
            DropZoneWorkflowBlock.prototype.getTopPadding = function () {
                return this.yPadding;
            };
            DropZoneWorkflowBlock.prototype.getLeftPadding = function () {
                return this.xPadding;
            };
            DropZoneWorkflowBlock.prototype.getRightPadding = function () {
                return this.xPadding;
            };
            DropZoneWorkflowBlock.prototype.getMyCenterPoint = function (gridCoordinate) {
                var xOffset = (gridCoordinate.x * this.blockWidth);
                var yOffset = (gridCoordinate.y * this.blockHeight);
                return new models.Coordinate((this.blockWidth / 2) + xOffset, this.blockHeight / 2 + yOffset);
            };
            DropZoneWorkflowBlock.prototype.draw = function (paper, coordinate) {
                var xOffset = (coordinate.x * this.blockWidth) + this.xPadding;
                var yOffset = (coordinate.y * this.blockHeight) + this.yPadding;
                var entireBlock = this.drawEntireBlock(paper, coordinate);
                this.svgElement = paper.rect(xOffset, yOffset, this.width, this.height, 5, 5);
                if (this.required)
                    this.svgElement.attr(this.attributes);
                else
                    this.svgElement.attr(this.optionalAttributes);
                var centerPoint = this.getMyCenterPoint(coordinate);
                var textAndRectangleGroup;
                if (this.required) {
                    this.textElement = paper.text(centerPoint.x, centerPoint.y + 5, this.label);
                    this.textElement.attr({ class: "alternate-text" });
                    textAndRectangleGroup = paper.group(entireBlock, this.svgElement, this.textElement);
                }
                else {
                    this.optionalTextElement = paper.text(centerPoint.x, centerPoint.y + 15, '(Optional)');
                    this.textElement = paper.text(centerPoint.x, centerPoint.y - 5, this.label);
                    this.optionalTextElement.attr(this.optionalTextAttributes);
                    this.textElement.attr(this.optionalTextAttributes);
                    textAndRectangleGroup = paper.group(entireBlock, this.svgElement, this.optionalTextElement, this.textElement);
                }
                var dropZoneGroup = paper.group(entireBlock, textAndRectangleGroup);
                return dropZoneGroup;
            };
            DropZoneWorkflowBlock.prototype.drawForToolbar = function (paper) {
                throw 'Not Supported';
            };
            DropZoneWorkflowBlock.prototype.highlightValidOption = function () {
                //services.WarsLogger.logDebug("Highlight Valid", this.logType);
                this.svgElement.attr({ class: "hover-valid-option" });
                this.textElement.attr({ class: 'text' });
            };
            DropZoneWorkflowBlock.prototype.highlightInvalidOption = function () {
                this.svgElement.attr({ class: "hover-invalid-option" });
                this.textElement.attr({ class: "alternate-text" });
                //services.WarsLogger.logDebug("Highlight Invalid", this.logType);
            };
            DropZoneWorkflowBlock.prototype.unHighlight = function () {
                this.svgElement.attr(this.attributes);
                this.textElement.attr({ class: "alternate-text" });
            };
            DropZoneWorkflowBlock.prototype.getDeleteCoordinate = function (coordinate) {
                throw "Never draw delete on drop zones";
            };
            DropZoneWorkflowBlock.prototype.getSettingsCoordinate = function (coordinate) {
                throw "Never draw delete on drop zones";
            };
            DropZoneWorkflowBlock.prototype.updateDrawingBasedOnLabelLengths = function () { };
            return DropZoneWorkflowBlock;
        }(models.NoOutputWorkflowBlock));
        models.DropZoneWorkflowBlock = DropZoneWorkflowBlock;
    })(models = warsApp.models || (warsApp.models = {}));
})(warsApp || (warsApp = {}));
